// @ts-expect-error This does not exist outside of polyfill which this is doing
if (typeof Promise.withResolvers === 'undefined') {
    // if (window)
    //     // @ts-expect-error This does not exist outside of polyfill which this is doing
    //     window.Promise.withResolvers = function () {
    //         let resolve, reject;
    //         const promise = new Promise((res, rej) => {
    //             resolve = res;
    //             reject = rej;
    //         });
    //         return { promise, resolve, reject };
    //     };

    Promise.withResolvers = function () {
        let resolve, reject;
        const promise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });
        return { promise, resolve, reject };
    };    
}

if (typeof URL !== 'undefined' && !URL.parse) {
    URL.parse = function (url, base) {
        try {
            return new URL(url, base);
        } catch (e) {
            return null;
        }
    };
}
